import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PackageSort'
})
export class PackageSortPipe implements PipeTransform {
  transform(items: any[]): any {
    if (!items) { return null; }
    return items.sort((packA, packB) => {
      return packA.PackageId - packB.PackageId;
    });
  }
}
